import Loader from '@/components/ui/Loader';
import { useGetActivity } from '@/hooks/useActivity';
import { useParams } from 'react-router';
import { useGetAllMySuppliers } from '@/api/supplier.api';
import ViewActivityForm from '@/components/activity/ViewActivityForm';
import { memo } from 'react';
import { useResourceLanguage } from '@/hooks/useResourceLanguage';

const ViewActivityFormMemo = memo(ViewActivityForm);

const ViewActivityPage = () => {
  const { benefitId = '' } = useParams();

  const { language, setLanguage } = useResourceLanguage();

  const { data: activity, isLoading, isSuccess } = useGetActivity(benefitId);
  const { data: suppliers } = useGetAllMySuppliers();

  return isLoading ? (
    <Loader />
  ) : (
    isSuccess && (
      <ViewActivityFormMemo
        activity={activity}
        suppliers={suppliers}
        language={language}
        setLanguage={setLanguage}
        key={`activity-${activity.id}`}
      />
    )
  );
};

export default ViewActivityPage;
